import React from 'react'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share'

import { Button, CopyToClipboard, Heading } from '../../components'

export default function SocialShare({ shareUrl, ticker }: { shareUrl: string; ticker: string }) {
  return (
    <CopyToClipboard
      label={<Heading level={5}>Copy and paste link in email, website, or forum</Heading>}
      text={shareUrl}
      bottomLeftContent={
        <>
          <FacebookShareButton url={shareUrl}>
            <Button as="span" size="small" contentClass="flex items-center">
              <FacebookIcon size={16} round={true} className="mr-1" />
              <span>Share</span>
            </Button>
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} via="FINVIZ_com" title={'$' + ticker} className="ml-1">
            <Button as="span" size="small" contentClass="flex items-center">
              <TwitterIcon size={16} round={true} className="mr-1" />
              <span>Twitter</span>
            </Button>
          </TwitterShareButton>
        </>
      }
    />
  )
}
